export const pumping ={
    pumping_form:{
        PDBShipRef:'',
        VesselName:'',
        PortType:'',
        PortName:'',

        Product1:'',

        P1CargoQuantity:'',
        P1TotalPumpingTime:'',
        P1AveragePressure:'',
        P1TotalStoppageTime:'',
        P1AverageDischargeRate:'',
        P1DurationforLineDisplacement:'',
        P1TimeTakentoMax:'',
        P1StrippingTime:'',
        P1BulkDischargeTime:'',
        P1BulkDischargeRate:'',
        P1MaxAchieveRate:'',

        Product2:'',
        
        P2CargoQuantity:'',
        P2TotalPumpingTime:'',
        P2AveragePressure:'',
        P2TotalStoppageTime:'',
        P2AverageDischargeRate:'',
        P2DurationforLineDisplacement:'',
        P2TimeTakentoMax:'',
        P2StrippingTime:'',
        P2BulkDischargeTime:'',
        P2BulkDischargeRate:'',
        P2MaxAchieveRate:'',

        Product3:'',

        P3CargoQuantity:'',
        P3TotalPumpingTime:'',
        P3AveragePressure:'',
        P3TotalStoppageTime:'',
        P3AverageDischargeRate:'',
        P3DurationforLineDisplacement:'',
        P3TimeTakentoMax:'',
        P3StrippingTime:'',
        P3BulkDischargeTime:'',
        P3BulkDischargeRate:'',
        P3MaxAchieveRate:'',

        CreatedTimestamp:'',
        ModifiedTimestamp:'',

        ReportFilename: 'Pumping',
        DateCreated: '',
        ModifyBy: '',
        ReportStatus: '',
        ProductNumber:'',
        Product:'',
    },
    product_number:0
}


// WEBPACK FOOTER //
// ./src/reducers/pumping/pumping.state.js